import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const getBankListSlice = createAsyncThunk(
  "bank/getBankList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/bank/getBankList", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
export const getBankByIdSlice = createAsyncThunk(
  "bank/getBankById",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/bank/getBankById", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const createBankSlice = createAsyncThunk(
  "bank/createBank",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/bank/createBank", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const updateBankSlice = createAsyncThunk(
  "bank/updateBank",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/bank/updateBank", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deleteBankSlice = createAsyncThunk(
  "bank/deleteBank",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/bank/deleteBank", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const initialState = {
  loading: false,
  bank: [],
  bankById: [],
  error: null,
  isLoading: false,
  createBankSuccessMessage: null,
  createBankErrorMessage: null,
  updateBankSuccessMessage: null,
  updateBankErrorMessage: null,
  deleteBankSuccessMessage: null,
  deleteBankErrorMessage: null,
  searchMessage: null,
  currentPage: 1,
  totalPages: null,
  hasMore: true,
  totalCount: 0,
};

const bankSlice = createSlice({
  name: "bank",
  initialState,
  reducers: {
    resetCreateMessages: (state) => {
      state.createBankSuccessMessage = null;
      state.createBankErrorMessage = null;
    },
    resetUpdateMessages: (state) => {
      state.updateBankSuccessMessage = null;
      state.updateBankErrorMessage = null;
    },
    resetDeleteMessages: (state) => {
      state.deleteBankSuccessMessage = null;
      state.deleteBankErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBankListSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBankListSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (!action.payload.success) {
          state.bank = [];
          state.totalCount = 0;
          state.totalPages = 1;
          state.searchMessage = action.payload.result?.message || "No data found";
          return;
        }
        const result = action.payload.result;
        state.bank = result.list || [];
        state.currentPage = Number(result.currentPage) || 1;
        state.totalPages = Number(result.totalPages) || 1;
        state.totalCount = Number(result.totalRecords) || 0;
        state.hasMore = result.hasMore ?? false;
        state.searchMessage = null;
      })

      .addCase(getBankListSlice.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getBankByIdSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBankByIdSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.searchMessage = action.payload.result.message;
        }
        state.bankById = action.payload.result.list;
      })

      .addCase(getBankByIdSlice.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(createBankSlice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createBankSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === false) {
          state.createBankErrorMessage = action.payload.result.message;
        } else {
          state.createBankSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(createBankSlice.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateBankSlice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateBankSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === true) {
          state.updateBankSuccessMessage = action.payload.result.message;
        } else {
          state.updateBankErrorMessage = action.payload.result.message;
        }
      })
      .addCase(updateBankSlice.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(deleteBankSlice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteBankSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === true) {
          state.deleteBankSuccessMessage = action.payload.result.message;
        } else {
          state.deleteBankErrorMessage = action.payload.result.message;
        }
      })
      .addCase(deleteBankSlice.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export const { resetCreateMessages, resetUpdateMessages, resetDeleteMessages } =
  bankSlice.actions;
export default bankSlice.reducer;
